var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/loyalty-unsubscribed.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
env.getTemplate("macros/urls.j2", false, "account/templates/partials/loyalty-unsubscribed.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("genericUrl")) {
var t_4 = t_1.genericUrl;
} else {
cb(new Error("cannot import 'genericUrl'")); return;
}
context.setVariable("genericUrl", t_4);
output += "\n\n<div class=\"urban-on-form\">\n\n    <p class=\"u-global-p\">\n        ";
output += runtime.suppressValue(env.getFilter("markdown_nowrap").call(context, (lineno = 7, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-loyalty-not-subscribed-message",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})]))), env.opts.autoescape);
output += "\n    </p>\n\n    ";
output += "\n    ";
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/loyalty-unsubscribed.j2"] , dependencies)